import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useCreateImages = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation((input) => client.media.uploadImages(input, useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError), {
        ...useMutationOptions,
        onError: useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError,
    });
};
//# sourceMappingURL=useCreateImages.js.map